"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Illustration = exports.ILLUSTRATION_TYPES = exports.ILLUSTRATION_SIZES = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _Illustration = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Illustration.css") : void 0);
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CSS_BLOCK = 'sapcnqr-illustration';
var ILLUSTRATION_SIZES = exports.ILLUSTRATION_SIZES = ['lg',
// scene
'md',
// dialog
'sm',
// spot
'xs' // dot
];
var ILLUSTRATION_TYPES = exports.ILLUSTRATION_TYPES = ['SimpleBalloon', 'BalloonSky', 'SimpleBell', 'SimpleCalendar', 'SimpleCheckMark', 'SimpleConnection', 'SimpleEmptyDoc', 'SimpleEmptyList', 'EmptyList', 'SimpleError', 'SimpleMagnifier', 'SimpleMail', 'SimpleNotFoundMagnifier', 'SimpleNoSavedItems', 'SimpleReload', 'SimpleTask', 'IllustratedFaceID', 'AddColumn', 'AddDimensions', 'AddPeople', 'Connection', 'EmptyCalendar', 'EmptyPlanningCalendar', 'ErrorScreen', 'FilterTable', 'GroupTable', 'NewMail', 'NoColumnsSet', 'NoDimensionsSet', 'NoFilterResults', 'NoMail', 'NoSavedItems', 'PageNotFound', 'ReloadScreen', 'ResizeColumn', 'SearchEarth', 'SearchFolder', 'SignOut', 'SleepingBell', 'SortColumn', 'SuccessHighFive', 'SuccessScreen', 'Tent', 'UnableToLoadImage', 'UploadCollection', 'UploadToCloud', 'Survey', 'NoTasks', 'Car', 'CarAlt', 'Hotel', 'HotelAlt', 'Kite', 'KiteAlt', 'Plane', 'PlaneAlt', 'Rail', 'RailAlt', 'Avatar', 'Teams'];
var Illustration = exports.Illustration = function Illustration(props) {
  var _context;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var _a = addChildProps ? (0, _assign.default)((0, _assign.default)({}, props), addChildProps(Illustration, props)) : props,
    ariaHidden = _a.ariaHidden,
    className = _a.className,
    Component = _a.Component,
    screenReaderOnly = _a.screenReaderOnly,
    title = _a.title,
    titleProps = _a.titleProps,
    variant = _a.variant,
    otherProps = __rest(_a, ["ariaHidden", "className", "Component", "screenReaderOnly", "title", "titleProps", "variant"]);
  var uniqueId = (0, _useUniqueId.default)();
  if (titleProps === null || titleProps === void 0 ? void 0 : titleProps.id) {
    uniqueId = titleProps.id;
  }
  var classnames = _bind.default.bind(_Illustration.default);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Component, (0, _assign.default)({}, otherProps, {
    "aria-hidden": ariaHidden,
    role: "img",
    className: classnames(CSS_BLOCK, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, variant === null || variant === void 0 ? void 0 : variant.toLowerCase()), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--screen-reader-only"), screenReaderOnly), className),
    "aria-labelledby": title && !ariaHidden ? uniqueId : undefined
  })), title && ( /*#__PURE__*/_react.default.createElement("span", (0, _assign.default)({}, titleProps, {
    id: uniqueId,
    className: classnames("".concat(CSS_BLOCK, "__title"), titleProps === null || titleProps === void 0 ? void 0 : titleProps.className)
  }), title)));
};
Illustration.displayName = 'Illustration';
var _default = exports.default = Illustration;